import React from 'react';
import { Box, CardMedia, makeStyles } from '@material-ui/core';
import postDefaultImg from '../../img/image_default.svg';
const PostImage = ({ image, imageCount, imagePosition }) => {
  const classes = useStyles();
  const moreImages = imageCount - 3;
  return (
    <Box height="inherit" className={classes.defaultImg}>
      <CardMedia
        className={classes.media}
        image={image}
        alt="sheroes user post image"
      >
        {imageCount > 3 && imagePosition === 2 && (
          <Box className={classes.moreImagesText}>+ {moreImages}</Box>
        )}
      </CardMedia>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  media: {
    width: '100%',
    height: '100%',
    marginBottom: theme.spacing(2),
    position: 'relative',
    borderRadius: theme.spacing(3),
  },
  moreImagesText: {
    height: '100%',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    fontSize: '24px',
    color: 'white',
    background: 'rgba(0,0,0,0.5)',
    borderRadius: theme.spacing(3),
  },
  defaultImg: {
    background: theme.palette.grey[100],
    borderRadius: theme.spacing(3),
    '&::before': {
      backgroundImage: 'url(' + postDefaultImg + ')',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      content: `''`,
      position: 'absolute',
      left: theme.spacing(0),
      right: theme.spacing(0),
      width: 'auto',
      height: '100%',
    },
  },
}));
export default PostImage;
